module.exports = __webpack_public_path__ + "static/media/masthead-image.29aa9dd0.png";